/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAntennaBarsOff = createReactComponent("outline", "antenna-bars-off", "IconAntennaBarsOff", [["path", { "d": "M6 18v-3", "key": "svg-0" }], ["path", { "d": "M10 18v-6", "key": "svg-1" }], ["path", { "d": "M14 18v-4", "key": "svg-2" }], ["path", { "d": "M14 10v-1", "key": "svg-3" }], ["path", { "d": "M18 14v-8", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

export { IconAntennaBarsOff as default };
//# sourceMappingURL=IconAntennaBarsOff.mjs.map
